module.exports = __webpack_public_path__ + "static/media/timetable1.3f652985.svg";